export const OrderPageTabs = {
    ALL: 'ALL',
    DELIVERY: 'DELIVERY',
    TAKE_AWAY: 'TAKE_AWAY',
    EAT_HERE: 'EAT_HERE',
    ROOM_SERVICE: 'ROOM_SERVICE',
} as const;

export type OrderPageTab = (typeof OrderPageTabs)[keyof typeof OrderPageTabs];
